if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            const idInput = this.form?.querySelector('[name=id]');
            if (idInput) idInput.disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cartDrawer = document.querySelector('cart-drawer');
            this.cart = document.querySelector('cart-notification') || this.cartDrawer;
            this.submitButton = this.querySelector('[type="submit"]');

            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

            this.hideErrors = this.dataset.hideErrors === 'true';
            this.cartNotification = document.getElementById('cart-notification');
            this.handleCartNotificationOutsideInteraction = this.handleCartNotificationOutsideInteraction.bind(this);
            this.handleCartNotificationResize = this.updateCartNotificationOffset.bind(this);
            this.cartType = window.otherSettings && window.otherSettings.cartType
                ? window.otherSettings.cartType
                : 'drawer';
            this.bindCartNotificationEvents();
            if (this.cartNotification) {
                window.addEventListener('resize', this.handleCartNotificationResize);
                this.updateCartNotificationOffset();
            }
            this.variantChangeUnsubscriber = null;
        }

        connectedCallback() {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                const variantId = event?.data?.variant?.id;
                if (!variantId) return;
                this.refreshQuantityInCartFromCart(variantId);
            });
        }

        disconnectedCallback() {
            if (this.variantChangeUnsubscriber) {
                this.variantChangeUnsubscriber();
            }
            if (this.cartNotification) {
                window.removeEventListener('resize', this.handleCartNotificationResize);
            }
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('is-loading');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            const quantityAdded = parseInt(formData.get('quantity') || '1', 10);
            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            } else if (this.cartType === 'notification' || this.cartType === 'minimal') {
                formData.append('sections', 'cart-icon-bubble,cart-price');
                formData.append('sections_url', window.location.pathname);
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!this.cart && this.cartType !== 'notification' && this.cartType !== 'minimal') {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    const quickViewModalEl = document.getElementById('product-quickview-modal');
                    const modalEl = quickViewModalEl ? window.bootstrap5.Modal.getInstance(quickViewModalEl) : null;
                    if (modalEl && quickViewModalEl) {
                        if (quickViewModalEl.contains(document.activeElement)) {
                            const basketIcon = document.getElementById('basketIcon');
                            if (basketIcon) {
                                basketIcon.focus();
                            } else if (document.activeElement && typeof document.activeElement.blur === 'function') {
                                document.activeElement.blur();
                            }
                        }
                        modalEl.hide();
                    }

                    if (!this.error)
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response
                        });
                    this.error = false;
                    this.refreshQuantityInCartState(response.quantity);
                    if (this.cartType === 'notification') {
                        if (this.cart && typeof this.cart.renderContents === 'function') {
                            this.cart.renderContents(response, true);
                        } else {
                            this.renderHeaderCartSections(response.sections);
                        }
                        this.showCartNotification(response, quantityAdded);
                    } else if (this.cartType === 'minimal') {
                        if (this.cart && typeof this.cart.renderContents === 'function') {
                            this.cart.renderContents(response, true);
                        } else {
                            this.renderHeaderCartSections(response.sections);
                        }
                        this.applyMinimalCardFeedback();
                    } else {
                        this.cart.renderContents(response);
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.submitButton.classList.remove('is-loading');
                });
        }

        handleErrorMessage(errorMessage = false) {
            if (this.hideErrors) return;

            this.errorMessageWrapper =
                this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message') || document.errorMessageWrapper.querySelector('.product-form__error-message');

            if (errorMessage && !errorMessage.email) {
                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
                this.errorMessage.textContent = errorMessage;
            }
        }

        bindCartNotificationEvents() {
            if (!this.cartNotification || this.cartNotification.dataset.bound === 'true') return;
            const closeBtn = this.cartNotification.querySelector('#cart-notification-Close');
            const continueBtn = this.cartNotification.querySelector('#cart-notification-Continue');

            [closeBtn, continueBtn].forEach((button) => {
                if (!button) return;
                button.addEventListener('click', () => this.hideCartNotification());
            });

            this.cartNotification.dataset.bound = 'true';
        }

        hideCartNotification() {
            if (!this.cartNotification) return;
            if (this.cartNotification.contains(document.activeElement)) {
                const basketIcon = document.getElementById('basketIcon');
                if (basketIcon) {
                    basketIcon.focus({preventScroll: true});
                } else if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
            }
            this.cartNotification.classList.add('hidden');
            this.cartNotification.setAttribute('aria-hidden', 'true');
            document.removeEventListener('pointerdown', this.handleCartNotificationOutsideInteraction);
        }

        handleCartNotificationOutsideInteraction(event) {
            if (!this.cartNotification || this.cartNotification.classList.contains('hidden')) return;
            if (this.cartNotification.contains(event.target)) return;
            this.hideCartNotification();
        }

        getCartNotificationVariantText(productData) {
            if (productData.variant_title && productData.variant_title !== 'Default Title') {
                return productData.variant_title;
            }

            if (!Array.isArray(productData.options_with_values) || productData.options_with_values.length === 0) {
                return '';
            }

            return productData.options_with_values
                .map((option) => `${option.name}: ${option.value}`)
                .join(' / ');
        }

        showCartNotification(productData, quantityAdded) {
            if (!this.cartNotification) return;

            const titleEl = this.cartNotification.querySelector('#cart-notification-Title');
            const variantEl = this.cartNotification.querySelector('#cart-notification-Variant');
            const qtyEl = this.cartNotification.querySelector('#cart-notification-Qty');
            const imageWrapEl = this.cartNotification.querySelector('#cart-notification-ImageWrap');
            const imageEl = this.cartNotification.querySelector('#cart-notification-Image');

            const productTitle = productData.product_title || productData.title || '';
            const variantText = this.getCartNotificationVariantText(productData);
            const quantityLabel = qtyEl ? qtyEl.dataset.label : 'Quantity';
            const productImage = productData.featured_image && productData.featured_image.url ? productData.featured_image.url : '';

            if (titleEl) titleEl.textContent = productTitle;

            if (variantEl) {
                variantEl.textContent = variantText;
                variantEl.classList.toggle('hidden', !variantText);
            }

            if (qtyEl) {
                qtyEl.textContent = `${quantityLabel}: ${Number.isNaN(quantityAdded) ? 1 : quantityAdded}`;
            }

            if (imageEl && imageWrapEl) {
                if (productImage) {
                    imageEl.src = productImage;
                    imageEl.alt = productTitle;
                    imageWrapEl.classList.remove('hidden');
                } else {
                    imageEl.removeAttribute('src');
                    imageEl.alt = '';
                    imageWrapEl.classList.add('hidden');
                }
            }

            const activeElement = document.activeElement;
            if (activeElement && typeof activeElement.blur === 'function') {
                activeElement.blur();
            }

            this.cartNotification.classList.remove('hidden');
            this.cartNotification.setAttribute('aria-hidden', 'false');
            this.updateCartNotificationOffset();
            if (typeof this.cartNotification.focus === 'function') {
                this.cartNotification.focus({preventScroll: true});
            }

            setTimeout(() => {
                if (!this.cartNotification || this.cartNotification.classList.contains('hidden')) return;
                document.addEventListener('pointerdown', this.handleCartNotificationOutsideInteraction);
            }, 0);
        }

        updateCartNotificationOffset() {
            if (!this.cartNotification) return;
            const parent = this.cartNotification.parentElement;
            if (!parent) return;

            const parentRect = parent.getBoundingClientRect();
            const offsetFromViewportEdge = Math.max(window.innerWidth - parentRect.right, 0);
            const isRtl = document.documentElement.getAttribute('dir') === 'rtl';

            if (isRtl) {
                this.cartNotification.style.left = `${offsetFromViewportEdge}px`;
                this.cartNotification.style.removeProperty('right');
                return;
            }

            this.cartNotification.style.right = `${offsetFromViewportEdge}px`;
            this.cartNotification.style.removeProperty('left');
        }

        renderHeaderCartSections(sections = {}) {
            if (!sections) return;
            const parser = new DOMParser();

            if (sections['cart-icon-bubble']) {
                const bubbleMarkup = parser
                    .parseFromString(sections['cart-icon-bubble'], 'text/html')
                    .querySelector('.shopify-section');
                const bubbleTarget = document.getElementById('cart-icon-bubble');

                if (bubbleMarkup && bubbleTarget) {
                    bubbleTarget.innerHTML = bubbleMarkup.innerHTML;
                }
            }

            if (sections['cart-price']) {
                const priceMarkup = parser
                    .parseFromString(sections['cart-price'], 'text/html')
                    .querySelector('.shopify-section');
                const priceTarget = document.getElementById('cart-price');

                if (priceMarkup && priceTarget) {
                    priceTarget.innerHTML = priceMarkup.innerHTML;
                }
            }
        }

        updateQuantityInCartMarkup(inCartQty) {
            const scope = this.closest('section[id^="MainProduct-"]')
                || this.closest('quick-view-modal')
                || document;

            scope.querySelectorAll('input[name="quantity"]').forEach((quantityInput) => {
                quantityInput.dataset.cartQuantity = `${inCartQty}`;
            });

            scope.querySelectorAll('.js-product-form-input label[data-in-cart-template]').forEach((qtyLabel) => {
                const qtyInCartEl = qtyLabel.querySelector('.js-quantity-in-cart');
                if (!qtyInCartEl) return;

                if (inCartQty > 0) {
                    const quantityCartEl = qtyInCartEl.querySelector('.quantity-cart');
                    if (quantityCartEl) {
                        quantityCartEl.textContent = `${inCartQty}`;
                    } else {
                        const template = qtyLabel.dataset.inCartTemplate || '<span class="quantity-cart">[quantity]</span> in cart';
                        qtyInCartEl.innerHTML = `(${template.replace('[quantity]', inCartQty)})`;
                    }
                    qtyInCartEl.classList.remove('hidden');
                } else {
                    qtyInCartEl.innerHTML = '';
                    qtyInCartEl.classList.add('hidden');
                }
            });
        }

        refreshQuantityInCartState(immediateQty) {
            const parsedImmediateQty = parseInt(immediateQty, 10);
            if (Number.isNaN(parsedImmediateQty)) return;
            this.updateQuantityInCartMarkup(parsedImmediateQty);
        }

        refreshQuantityInCartFromCart(variantId) {
            const variantIdNum = parseInt(variantId, 10);
            if (Number.isNaN(variantIdNum)) return;

            fetch('/cart.js')
                .then((response) => response.json())
                .then((cart) => {
                    const inCartQty = (cart.items || []).reduce((sum, item) => {
                        const itemVariantId = parseInt(item.variant_id || item.id, 10);
                        return itemVariantId === variantIdNum ? sum + (item.quantity || 0) : sum;
                    }, 0);
                    this.updateQuantityInCartMarkup(inCartQty);
                })
                .catch((e) => {
                    console.error(e);
                });
        }

        applyMinimalCardFeedback() {
            const productCard = this.closest('.product-card');
            if (!productCard || !this.submitButton) return;

            const productUrl = this.dataset.productUrl;
            if (!productUrl) return;

            const addedLink = document.createElement('a');
            addedLink.href = productUrl;
            addedLink.className = this.submitButton.className;
            addedLink.classList.remove('btn-primary');
            if (this.submitButton.id) addedLink.id = `${this.submitButton.id}-added`;
            addedLink.textContent = 'Added to cart';

            this.submitButton.replaceWith(addedLink);
            this.submitButton = addedLink;
        }
    });
}
